// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';
// import TimePicker from 'react-times';
// import 'react-times/css/classic/default.css';
// import 'react-times/css/material/default.css';
import TimePicker from 'react-gradient-timepicker';
import { Multiselect } from 'react-widgets';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

class EditFixture extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      fixture: {
        "id": props.match.params.id,
        "name": "",
        "venue": "",
        "game_type": 1,
        "age_group_id": '',
        "game_level_id": 1,
        "game_type_str":'',
        "day_of_week": 0,
        "start_time": "19:30:00",
        "end_time": "20:15:00",
        "max_subscribers": 30,
        "batch_size": 14,
        "home_batch_vote_start_duration": "1 00:00:00",
        "flexi_batch_vote_start_duration": "04:00:00",
        "cut_off_duration": "01:00:00",
        "price": 200.0,
        "is_skill_matching_required":false
      },
      data_uploaded: false,
      data_error: false,
      venues: [],
      game_types: [],
      game_levels: [],
      age_groups: [],
      selected_buddies: [],
      buddies: [],
      temp_buddies: [],
      game_type_specific_groups:[],
      buddy_availability_dialog:false,
      not_eligible_buddies:[]
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onStartTimeChange = this.onStartTimeChange.bind(this);
    this.onEndTimeChange = this.onEndTimeChange.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.onChange = this.onChange.bind(this);
  }


  componentDidMount() {
    this.getFixtureList();
    this.getAllBuddies();
  }

handleSkillCheckingCheckbox = (e) => {
    var new_value =  Object.assign({}, this.state.fixture);
    new_value['is_skill_matching_required'] = e.target.checked
    this.setState({fixture:new_value});
  }

  getFixtureList() {
     const url = `${getLocationOrigin()}/eagleeye/${this.state.id}/get_details_for_edit_fixture/`;
     const options = {...defaultOptions};

     fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ venues: data.venues, game_types: data.venues[0].game_types, fixture: data.fixture, age_groups: data.age_groups },()=>{this.setData(data)}))
       .catch(error => error);
  }

  getAllBuddies(){
    const url = `${getLocationOrigin()}/cm/get_buddies/?fixture=${this.state.id}`;
    const options = {...defaultOptions};

    return fetch(url, options)
    .then(checkStatus)
    .then(parseJSON)
    .then(data => {
        console.log('result',data)
        this.setState({buddies:data.buddies});
    }).catch(error => error);
    }

  postEditedFixture(data, props) {
    const url = `${getLocationOrigin()}/eagleeye/edit_fixture/`;
    const options = {...defaultOptions};
    var bud_ids = []
    for( var i in this.state.selected_buddies)
    {
      bud_ids.push(this.state.selected_buddies[i].id)
    }
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({'fixture': data,
                                      'buddies': bud_ids
                                    });
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then((response) => {                      // first then()
          if(response.success){
            if(response.not_eligible_buddies && response.not_eligible_buddies.length > 0){
              this.setState({not_eligible_buddies:response.not_eligible_buddies,buddy_availability_dialog:true})
            }
            else{
              alert(response.message);
              props.history.goBack();
            }
          }
          else{
            alert(response.message)
          }
          
      })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
  }

  setData(data){
    let venue_id = data.fixture.venue
    let venue = data.venues.find(ven => ven.id == venue_id)
    let games = venue.games
    let game = games.find(game => game.game_id == data.fixture.game)
    console.log('passed game',game)
    let game_type = game.game_types.find(game_type => game_type.pk == data.fixture.game_type)
    console.log('passed game type',game.game_types)
    let gt_specific_groups = game_type.age_groups
    console.log('game_type_specific_groups',gt_specific_groups)
    let game_levels = venue.game_levels
    var new_selected_one = Object.assign({}, this.state.fixture);
    new_selected_one['start_time'] = data.fixture.start_time.substring(0,5)
    new_selected_one['end_time'] = data.fixture.end_time.substring(0,5)
    new_selected_one['game_level_id'] = data.fixture.game_level_id
    var selected_bud = this.state.buddies.filter(buddy => data.fixture.buddies.includes(buddy.id))
    this.setState({game_levels:game_levels,fixture:new_selected_one,selected_buddies:selected_bud,game_type_specific_groups:gt_specific_groups})
  }

  dayOfWeek() {
    return [
      {id:0, name: 'Monday'},
      {id:1, name: 'Tuesday'},
      {id:2, name: 'Wednesday'},
      {id:3, name: 'Thursday'},
      {id:4, name: 'Friday'},
      {id:5, name: 'Saturday'},
      {id:6, name: 'Sunday'},
    ]
  }

  handleChange(event) {
    const name = event.target.name;
    var new_selected_one = Object.assign({}, this.state.fixture);
    new_selected_one[name] = event.target.value
    console.log('asdddddddddd');
    console.log(new_selected_one);
    this.setState({fixture: new_selected_one});
  }

  handleSubmit(event) {
    event.preventDefault();
    console.log('Submit');
    console.log(this.state.fixture);
    this.postEditedFixture(this.state.fixture, this.props);
    console.log('post');
    console.log(this.state);
  }

  onStartTimeChange(options) {
    console.log('options',options)
    var new_value =  Object.assign({}, this.state.fixture);
    new_value['start_time'] = options['format24']
    this.setState({fixture: new_value});
  }

  onEndTimeChange(options) {
    console.log('options',options)
    var new_value =  Object.assign({}, this.state.fixture);
    new_value['end_time'] = options['format24']
    this.setState({fixture: new_value});
  }

  onSelect(optionsList, selectedItem) {
    this.state.temp_buddies.push(optionsList)
    this.setState({ selected_buddies: this.state.temp_buddies});
  }

  onChange(dataItem,event){
    this.setState({selected_buddies:dataItem.map(x =>x)});
  }

  handleClose = () => {
    this.setState({buddy_availability_dialog:false});
    this.props.history.goBack();
  };

  render() {
    console.log('state',this.state.fixture.game_type)

    const okaction = [
      <FlatButton
        label="OK"
        primary={true}
        onClick={this.handleClose}
      />
    ];

    return(
      <div style={styles.container}>
        <div className="row col-md-8 table-bordered" style={styles.table}>
          <div style={styles.main_header} className="col-md-12 label_blue_1">
            Edit Fixture
          </div>
          <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Batch Name
              </div>
              <input type="text"
                style={styles.input}
                name="name"
                value={this.state.fixture.name}
                onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Venue *
              </div>
              <select name="venue" className="col-md-6" style={styles.item_body} value={this.state.fixture.venue}
                onChange={this.handleChange} disabled>
                {
                  this.state.venues.map((x, index) => (
                  <option key={x.id} value={x.id}>{x.name}</option>
                  ))
                }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Game type *
              </div>
              {/*<select name="game_type" style={styles.item_body} className="col-md-6"
                value={this.state.fixture.game_type} onChange={this.handleChange} disabled>
                {
                  this.state.game_types.map((x, index) => (
                  <option key={x.pk} value={x.pk}>{x.game + ' ' + x.name}</option>
                  ))
                }
              </select>*/}
              <textField style={{width:'50%'}} readOnly={true}>{this.state.fixture.game_type_str}</textField>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Is skill matching required ?
              </div>
              <label>
                      <input type="checkbox"
                      checked={this.state.fixture.is_skill_matching_required}
                      onChange={(e) => this.handleSkillCheckingCheckbox(e)}
                    />
              </label>
            </div>
             <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Game Level
              </div>
              <select name="game_level_id" style={styles.item_body} className="col-md-6"
                value={this.state.fixture.game_level_id} onChange={this.handleChange}>
                {
                  this.state.game_levels.map((x, index) => (
                  <option key={x.pk} value={x.pk}>{x.game.name + ' ' + x.name}</option>
                  ))
                }
              </select>
            </div>
             <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Age Group
              </div>
              <select name="age_group_id" style={styles.item_body} className="col-md-6" value={this.state.fixture.age_group_id} onChange={this.handleChange}>
                <option>--select--</option>
                {
                  this.state.game_type_specific_groups.length > 0 ?
                  this.state.game_type_specific_groups.map((x, index) => (
                  <option key={x.id} value={x.id}>{x.abbreviation}</option>
                  ))
                  :
                  this.state.age_groups.map((x, index) => (
                  <option key={x.id} value={x.id}>{x.abbreviation}</option>
                  ))
                }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
                <div style={{width:'50%'}} className="col-md-6">
                    <div style={styles.item_header} className="col-md-6">
                        <span  style={{display:'contents',marginBottom:'1%',marginBottom:10}}>Start Time </span>
                    </div>
                    <div className='col-md-6' >
                        <TimePicker
                          time={this.state.fixture.start_time}
                          headerColor='#84888A'
                          color1='#84888A'
                          className="timepicker"
                          placeholder="Start Time"
                          onSet={this.onStartTimeChange}
                        />
                    </div>
                </div>
                <div style={{width:'50%'}} className="col-md-6">
                    <div style={styles.item_header} className="col-md-6">
                        <span  style={{display:'contents',marginBottom:'1%',marginBottom:10}}>End Time </span>
                    </div>
                    <div className='col-md-6' >
                      <TimePicker
                            time={this.state.fixture.end_time}
                            headerColor='#84888A'
                            color1='#84888A'
                            className="timepicker"
                            placeholder="End Time"
                            onSet={this.onEndTimeChange}
                          />
                    </div>
                </div>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Max Subscribers
              </div>
              <input type="text" style={styles.input} name="max_subscribers" className="required"
                value={this.state.fixture.max_subscribers} onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Max Vote In
              </div>
              <input type="text" style={styles.input} name="batch_size" className="required"
                value={this.state.fixture.batch_size} onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Per Session Price
              </div>
              <input type="text" style={styles.input} name="price" className="required"
                value={this.state.fixture.price} onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Home batch Vote In Start
              </div>
              <input type="text" style={styles.input} name="home_batch_vote_start_duration" className="required"
                value={this.state.fixture.home_batch_vote_start_duration} onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Flexi Start
              </div>
              <input type="text" style={styles.input} name="flexi_batch_vote_start_duration" className="required"
                value={this.state.fixture.flexi_batch_vote_start_duration} onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Cut Off Duration
              </div>
              <input type="text" style={styles.input} name="cut_off_duration" className="required"
                value={this.state.fixture.cut_off_duration} onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Buddies
              </div>
              <div className="col-md-6">
                <Multiselect
                  id="1"  
                  placeholder="Buddies"
                  data={this.state.buddies}
                  value = {this.state.selected_buddies}
                  textField='buddy'
                  onSelect={this.onSelect} 
                  onChange={this.onChange}
                  filter='contains' 
                 />
              </div>
            </div>

            <div style={styles.items,{color:'red',fontSize:'1em',paddingLeft:'5%',textAlign:'left'}} className='col-md-12'>
                * Some details can't be edited. 
            </div>

            <div style={styles.button_submit} className="col-md-12">
              <input className="button1" type="submit" value="Submit"/>
            </div>
            <div className="col-md-12">
              {this.state.data_uploaded?<div className="text-success" style={styles.success}>* Fixture created successfully.</div>:''}
              {this.state.data_error?<div className="text-danger" style={styles.success}>* Error, creation failed.</div>:''}
              { this.state.not_eligible_buddies &&
                <div className="col-md-12" style={{flexDirection:'row',textAlign:'center'}}>
                  <Dialog
                    actions={okaction}
                    modal={false}
                    open={this.state.buddy_availability_dialog}
                    onClick={this.handleClose}
                    autoDetectWindowHeight={true}
                    autoScrollBodyContent={true}
                    scroll={scroll}
                    dividers={scroll === 'paper'}
                  >

                  <div style={styles.main_header} className="col-md-12">
                    <h4 style={{textAlign:'center'}}>These buddies are not available</h4>
                  </div>

                {
                  this.state.not_eligible_buddies.map((buddy,index)=>
                    <div className="col-md-12" style={{flexDirection:'row',textAlign:'center'}}>
                      {buddy.name} is tagged to fixture {buddy.fixture_value}.
                    </div>
                    )
                }

                </Dialog>
                </div>
              }
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default EditFixture;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/editFixture/index.js